import React from "react";
import { Breadcrumbs } from "@material-tailwind/react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { MdOutlineAddPhotoAlternate } from "react-icons/md";
import { MdOutlineHomeWork, MdOutlinePayment } from "react-icons/md";
import { MdOutlinePool } from "react-icons/md";
import { MdOutlineWifi } from "react-icons/md";
import { SlScreenDesktop } from "react-icons/sl";
import { GiMoneyStack } from "react-icons/gi";
import { AiOutlineEdit } from "react-icons/ai";
import { useState, useEffect } from "react";
import Loading from "../../../COMPONENTS/Loading/Loading";
import { GoArrowLeft } from "react-icons/go";
import SidebarTop from "../../SidebarTop";
import { LiaCocktailSolid } from "react-icons/lia";
import { WiSnowflakeCold } from "react-icons/wi";
import { LiaUmbrellaBeachSolid } from "react-icons/lia";
import { IoMdPin, IoIosMail } from "react-icons/io";
import { CiCalendarDate } from "react-icons/ci";
import { ToastContainer, toast } from "react-toastify";
import Restau from "../../../../API/tourisme/restaurant/index";
import { FaPhoneAlt } from "react-icons/fa";
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import { loadStripe } from '@stripe/stripe-js';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import DialogActions from '@mui/material/DialogActions';
import { Button,Form } from "react-bootstrap";
import Select from 'react-select';
import { useTranslation } from "react-i18next";
import Create from "../../../../Payment/Create";



const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

// Clé publique Stripe
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function PaymentPopup({ open,dollarP, user_Id, montant, email, onSuccess, userPrenom,userNom, formData, onClose }) {
    const [isDialogOpen, setIsDialogOpen] = useState(open);

    useEffect(() => {
        setIsDialogOpen(open);
    }, [open]);
    //console.log(email)
    const handleOpenAZ = () => {
        //alert("AZPay")
        // axios.get('/api/payment/create', {
        //     params: {
        //         provider: 'AZPay',
        //         item_id: 'item_id',
        //         item_name: 'item',
        //         amount: montant, // Assurez-vous de convertir les devises correctement
        //         currency: 'XOF',
        //         email: email,   
        //         description: 'Publicité sur Mon Bon Sejour', 
        //         phone: tel,
        //         email: email,
        //         last_name: userNom,  // Remplacez par les informations du client
        //         first_name: userPrenom,  
        //         success_url: 'successUrl',
        //         customer_number: userId
        //     }
        // }).then(response => {
        //     if (response.data.fail) {
        //         if (response.data.type_error === "balance_insufficient") {
        //             //setError("Votre solde est insuffisant pour effectuer cette transaction.");
        //         }
        //     } else if (response.data.success_url) {
        //         window.location.href = response.data.success_url;
        //     } else {
        //         //setError("Une erreur s’est produite, veuillez réessayer !");
        //     }
        // }).catch(error => {
        //     console.error("Erreur lors de la requête AZPay :", error);
        // });
    };


    const handleClose = () => {
        setIsDialogOpen(false);
        if (onClose) onClose();  
    };


    const handlePayCancel = () => {
        //console.log('Paiement annulé');
        handleClose();
    };
    const PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY;
    const checkoutButtonOptions = {
        public_key: PUBLIC_KEY,
        transaction: {
          amount: montant,
          description: 'Publicité sur Mon Bon Sejour',
          callback_url: 'Dashboard/Publications/Hebergement/Ajouter_des_hebergements',
          custom_metadata: {
                user_id: user_Id,
                //additional_info: 'Some additional info'
            }
        },
        currency: {
          iso: 'XOF'
        },
        customer: {
          lastname: userNom,
          firstname: userPrenom,
          email: email
        },
        button: {
          class: 'btn btn-primary',
          text: 'Payer ' + montant + ' FCFA'
        },
        onComplete(resp) {
          const FedaPay = window['FedaPay'];
          if (resp.reason === FedaPay.DIALOG_DISMISSED) {
            //window.location.reload();
            toast.success('Vous avez fermé la boite de dialogue');
          } else {
            setIsDialogOpen(false);
            onSuccess();
    
            // Extraire les données de la transaction
            // const transactionData = {
            //   transaction_id: resp.transaction.id,
            //   reference: resp.transaction.reference,
            //   amount: resp.transaction.amount,
            //   description: resp.transaction.description,
            //   status: resp.transaction.status,
            //   approved_at: resp.transaction.approved_at,
            //   customer: {
            //     firstname: resp.transaction.customer.firstname,
            //     lastname: resp.transaction.customer.lastname,
            //     email: resp.transaction.customer.email,
            //   },
            //   transaction_key: resp.transaction.transaction_key,
            //   fees: resp.transaction.fees,
            //   mode: resp.transaction.mode,
            //   amount_debited: resp.transaction.amount_debited,
            //   custom_metadata:resp.transaction.custom_metadata.user_id,
            // };
            
            // fetch(`${process.env.REACT_APP_BASE_URL}/api/fedapay/callback`, {
            //   method: 'POST',
            //   headers: {
            //     'Content-Type': 'application/json',
            //     'Accept': 'application/json'
            //   },
            //   body: JSON.stringify(transactionData),
            // })
            // .then(response => {
            //   if (!response.ok) {
            //     return response.json().then(errorData => {
            //       throw new Error(errorData.message || 'Something went wrong');
            //     });
            //   }
            //   return response.json();
            // })
            // .then(data => {
            //   console.log('Transaction saved:', data);
            // })
            // .catch((error) => {
            //   console.error('Error:', error);
            // });
          }
    
          //console.log(resp.transaction);
          
        },
        onCancel: handlePayCancel
      };
    
      // Lancer le paiement FedaPay
      const handlePayment = () => {
        const FedaPay = window['FedaPay'];
        FedaPay.init(checkoutButtonOptions).open();
      };

       //stripe
    const createPaymentSession = async () => {
        try {
            const successUrl = `${window.location.origin}/Dashboard/Publications/Hebergement/Ajouter_des_hebergements`;
            const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/payment/stripe`, {
            provider: 'stripe',
            item_id: 'item_id',
            item_name: 'item',
            amount: Math.round((montant / dollarP) * 100),
            currency: 'USD',
            email: email,
            description: 'Publicité sur Mon Bon Sejour',
            last_name: userNom,
            first_name: userPrenom,
            success_url: successUrl,
            customer_number:1,
          });
  
          if (response.data) {
            localStorage.setItem('sessionId', response.data.sessionId);
              return response.data.sessionId;
              
            } else {
                console.error("Erreur lors de la création de la session de paiement :", response.data);
            }
        } catch (error) {
            console.error("Erreur lors de la requête Card :", error);
        }
    };
    
    const handleStripePayment = async () => {
        const sessionId = await createPaymentSession();
        if (sessionId) {
            const stripe = await stripePromise;
            //console.log(sessionId)
            
            const { error } = await stripe.redirectToCheckout({
                sessionId: sessionId,
            });
    
            if (error) {
                console.error("Erreur lors de la redirection vers Stripe :", error);
            } else {
                // Paiement réussi, appel de la fonction onSuccess
                //onSuccessStripe();
            }
            
        }
    };
    

    return (
      <BootstrapDialog 
          onClose={handleClose} 
          aria-labelledby="customized-dialog-title" 
          open={isDialogOpen}
        >
          <DialogTitle 
            sx={{ 
              m: 0, 
              p: 2, 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'space-between' 
            }} 
            id="customized-dialog-title" 
            className='text-[#FE7F2D]'
          >
            <span className="flex items-center space-x-3">
              <p>Veuillez choisir le mode de paiement</p>
            </span>
            <IconButton 
              aria-label="close" 
              onClick={handleClose}
              sx={{
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
        
          <DialogContent dividers>
            <DialogActions
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                alignItems: 'center',
                gap: '10px' // Remplace marginBottom pour un espacement plus uniforme
              }}
            >
              {[
                {
                  onClick: handleOpenAZ,
                  label: `AZ-PAY : ${montant} F CFA`
                },
                {
                  onClick: handleStripePayment,
                  label: `Carte bancaire : ${montant} F CFA`
                },
                {
                  onClick: handlePayment,
                  label: checkoutButtonOptions.button.text
                }
              ].map((buttonConfig, index) => (
                <Button
                  key={index}
                  onClick={buttonConfig.onClick}
                  style={{
                    textTransform: 'none',
                    backgroundColor: '#233D4D',
                    color: 'white',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '10px', // Ajout de padding pour une meilleure apparence
                    marginLeft: '10px', // Ajout de padding pour une meilleure apparence
                  }}
                >
                  {buttonConfig.label}
                </Button>
              ))}
            </DialogActions>
          </DialogContent>
      </BootstrapDialog>
    );
}

function EditRestaurant() {
  localStorage.setItem(
    "url",
    JSON.stringify("/Dashboard/Publications/Restaurant/Voir_des_restaurants")
  );

  const [data, setData] = useState(() => {
    // getting stored value
    const saved = localStorage.getItem("data");
    const initialValue = saved !== null ? JSON.parse(saved) : null;
    return initialValue;
  });

  const navigate = useNavigate();

  const [records, setRecords] = useState([]);
  const [tmprecords, setTmpecords] = useState([]);

  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  

  const [cities, setCities] = useState([]);
  const [countries, setCountries] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [address, setAddress] = useState([]);
  const [showInput,setShowInput] = useState(false)
  const [errors, setErrors] = useState({});
  const [priceD, setPriceD] = useState(null);
  const [pricePub, setPricePub] = useState(null);
  const [pictures,setPictures] = useState([]);
  const [dayr,setDayr] = useState(null)
  const [open,setOpen] = useState(false)
  const [options, setOptions] = useState(null);
  const [curr,setCurr] = useState();
  
  
  let fd = new FormData();


   const getPricePub = async () => {
        try {
          const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/prix/pub/restaurant`);
          //console.log(res.data.data.Prices);
          setPricePub(res.data.data.Prices);
        } catch (err) {
          console.log(err);
        }
      };
  
      const getPriceDollar = async () => {
          try {
            const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/prix/dollar`);
            //console.log(res.data.data.value_to_xof);
            setPriceD(res.data.data.value_to_xof);
          } catch (err) {
            console.log(err);
          }
      };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const location = useLocation();
  const id = location.state;

 const handleCountryChange = (selectedOption) => {
     // selectedOption contient directement l'objet { label, value }
     const { value } = selectedOption;
     //setChanged(true);
     setFormData({ ...formData, country: value});
     // Mettre à jour address.code
     setAddress(prevState => ({
       ...prevState,
       code: value
     }));
   
     // Requête pour récupérer les provinces
     axios
       .get(`${process.env.REACT_APP_BASE_URL}/api/province/list/${value}`)
       .then((response) => {
         //console.log(response.data.data);
         setProvinces(response.data.data);
       })
       .catch((err) => console.log(err));
   };
   
 
   const handleProvinceChange = (selectedOption) => {
     const { value } =selectedOption;
     //setChanged(true);
     setFormData({ ...formData, province: value });
     setAddress(prevState=>({
       ...prevState,
       code_province:value
     }))
 
     //city
     axios
       .get(`${process.env.REACT_APP_BASE_URL}/api/city/list/${value}`)
       .then((response) => {
         setCities(response.data.data);
       })
       //.then(response => console.log(response.data.data))
       .catch((err) => console.log(err));
   };
 
   const handleCityChange = (selectedCity)=>{
     setFormData({ ...formData, ville: selectedCity.value });
     setAddress(prevCity=>({
       ...prevCity,
       code_city:selectedCity.value
     }))
 }
  const checkboxClick= ()=>setShowInput(!showInput)


  useEffect(() => {
    if (!data) {
      navigate("/Connexion");
    }

    // Appel API pour récupérer la monnaie
    axios
    .get(`${process.env.REACT_APP_BASE_URL}/api/get/info/website`)
    .then((res) => {
        if (res.data.status === 200 ) {
         setCurr(res.data.currency);
        localStorage.setItem('id_currency', res.data.currency.id_currency);
        } else {
        console.warn("Réponse inattendue de l'API :", res.data);
        }
    })
    .catch((err) => {
        console.error("Erreur lors de l'appel à l'API :", err);
    });

    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/restaurant/show/${id}`)
      .then((response) => {
        setRecords(response.data.data);
        setTmpecords(response.data.data);
        setPictures(response.data.pictures)
      })
      //.then(response => console.log(response))
      .catch((err) => console.log(err));

    //country
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/country/list`)
      .then((response) => {
        setCountries(response.data.data);
      })
      //.then(response => console.log(response.data.data))
      .catch((err) => console.log(err));

    //adresse
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/annonce/info/${id}`)
      .then((response) => {
        setAddress(response.data.data);
      })
      .catch((err) => console.log(err));

      getPricePub();
      getPriceDollar()
    const timer = setTimeout(() => {
      // Après 5 secondes, masquer le spinner et rediriger l'utilisateur
      setLoading(false);
    }, 2000); // 5000 millisecondes = 5 secondes

    // Nettoyer le timer si le composant est démonté avant la fin du délai
    return () => clearTimeout(timer);
  }, []);

   useEffect(()=>{
      axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/province/list/${address.code}`)
      .then((response) => {
        //console.log(response.data.data);
        setProvinces(response.data.data);
      })
      .catch((err) => console.log(err));
  
       //city
       axios
       .get(`${process.env.REACT_APP_BASE_URL}/api/city/list/${address.code_province}`)
       .then((response) => {
         setCities(response.data.data);
       })
       //.then(response => console.log(response.data.data))
       .catch((err) => console.log(err));
  
    },[address.code,address.code_province])

 const ValidatedEditForm = ()=>{
    fd.append("id", id);
    fd.append("nom", formData.nom ?? records.title_announce);
    fd.append("methode", formData.methode ?? records.payment_method);
    fd.append("adresse", formData.lieu ?? records.contact_address);
    fd.append("balcon", formData.terasse ?? records.realstate_balcony);
    fd.append("camera", formData.TV ?? records.realstate_security);
    fd.append("desc", formData.msg ?? records.description_announce);
    fd.append("piscine", formData.piscine ?? records.realstate_swimming_pool);
    fd.append("prix", formData.prix ?? records.price_announce);
    fd.append("wifi", formData.wifi ?? records.realstate_wifi);
    fd.append("date_debut", formData.date_debut ?? records.date_debut);
    fd.append("date_fin", formattedDate ?? records.date_fin);

    fd.append("mail", formData.mail ?? records.contact_email);
    fd.append("tel", formData.phone ?? records.contact_phone);
    fd.append("pays", formData.country ?? records.contact_country);
    fd.append("ville", formData.ville ?? records.contact_city);
    fd.append("province", formData.province ?? records.contact_province);
    fd.append("update",'edit');


    Restau.verifyRestauForm(fd)
          .then((res)=>{
             if(res.data.status === 422)
             {
              setErrors(res.data.errors);
              setShowPopup(false)
              return;
             }else{
              if(formattedDate === null || totalPaid === 0 )
              {
                SubmitEditForm();
                return;
              }else{
               setShowPopup(true)
              }
          
        }
          }).catch((error)=>{
             console.log("Erreur lors de l'appel a l'Api ",error)
          })
 }

  const SubmitEditForm = (provider,paymentId,currencyId) => {
    fd.append("id", id);
    fd.append("nom", formData.nom ?? records.title_announce);
    fd.append("methode", formData.methode ?? records.payment_method);
    fd.append("adresse", formData.lieu ?? records.contact_address);
    fd.append("balcon", formData.terasse ?? records.realstate_balcony);
    fd.append("camera", formData.TV ?? records.realstate_security);
    fd.append("desc", formData.msg ?? records.description_announce);
    fd.append("piscine", formData.piscine ?? records.realstate_swimming_pool);
    fd.append("prix", formData.prix ?? records.price_announce);
    fd.append("wifi", formData.wifi ?? records.realstate_wifi);
    fd.append("date_debut", formData.date_debut ?? records.date_debut);
    fd.append("date_fin",formattedDate ?? records.date_fin);

    fd.append("mail", formData.mail ?? records.contact_email);
    fd.append("tel", formData.phone ?? records.contact_phone);
    fd.append("pays", formData.country ?? records.contact_country);
    fd.append("ville", formData.ville ?? records.contact_city);
    fd.append("province", formData.province ?? records.contact_province);



    for (let i = 0; i < document.getElementById("photo")?.files.length; i++) {
      fd.append("photo[]", document.getElementById("photo")?.files[i]);
    }
    //setLoading(true)
    Restau.submitEdit(fd)
      .then((res) => {
        if (res.data.status === 201) {

           if(provider !== null && paymentId !== null && currencyId !== null){
                                      const formD = {
                                              userId:data.azId,
                                              montant:totalPaid,
                                              provider: provider,
                                              payement_id:paymentId ,
                                              currency:currencyId,
                                              annonce_number: id,
                                              description:"Transaction de modification  d'un restaurant"
                                          }
                                      axios.post(`${process.env.REACT_APP_BASE_URL}/api/store/rechargement-paiememnt`,formD)
                                          .then((res)=>{
                                          if(res.data.status === 200){
                                          //toast.success(res.data.message);
                                          //console.log("enregistrement reussie")
                                          }
                                          }).catch((err)=>{
                                          console.log("Erreur lors de l'appel a l'API ",err)
                                          })
                              }
          toast.success(res.data.message);
          navigate("/Dashboard/Publications/Restaurant/Voir_des_restaurants");
        } else if (res.data.status === 422) {
          setErrors(res.data.errors);
          return;
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error("Erreur merci de reessayer !");
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmit = (event)=>{
     event.preventDefault();
     ValidatedEditForm();
  }
  const handlePopupSuccess = () => {
    setShowPopup(false);
    SubmitEditForm();
};

// Callback d'annulation du popup de paiement
const handlePopupCancel = () => {
  setShowPopup(false);
};

  const [formattedDate, setFormattedDate] = useState(null);
  const [totalPaid, setTotalPaid] = useState(null);
  
  let daysToAdd= null;
    const handleDaysChange = (event) => {
      daysToAdd = parseInt(event.target.value, 10); // Assurez-vous que la valeur est bien un nombre
      if (!isNaN(daysToAdd)) {

        const currentDate = new Date();
        const formattedCurrentDate = currentDate.toISOString().split('T')[0];
        let updatedEndDate = null;
        let DateBeforEnd = null;
        if(tmprecords.date_fin < formattedCurrentDate)
        {
            updatedEndDate = new Date(formattedCurrentDate);
        }else{
            updatedEndDate = new Date(tmprecords.date_fin);
            DateBeforEnd = new Date(tmprecords.date_fin).getDate() - new Date(formattedCurrentDate).getDate() 
        }
      
        setDayr(DateBeforEnd + daysToAdd)

        // Créez une copie de endDate pour éviter de modifier l'original à chaque changement
        updatedEndDate.setDate(updatedEndDate.getDate() + daysToAdd);

        const newFormattedDate = `${updatedEndDate.getFullYear()}-${(updatedEndDate.getMonth() + 1).toString().padStart(2, '0')}-${updatedEndDate.getDate().toString().padStart(2, '0')}`;
        setFormattedDate(newFormattedDate);  // Mise à jour de formattedDate
      }
    };

  useEffect(() => {
          if (curr) {
      
          setOptions({
              id_currency: curr.id_currency,
              success_url: window.location.origin ,
              cancel_url: window.location.href,
              amount:totalPaid,
              customer: {
              id: data.azId,
              first_name: data.userLastname ?? '',
              last_name: data.userName ?? '',
              email: data.userMail,
              phone: data.userTel,
              code_country: 'BJ'
              },
              seller_number: 1
          });
          }
      }, [curr,totalPaid]);  
  
  useEffect(() => {
    if (formattedDate !== null) {
      
      const currentDate = new Date();
      const formattedCurrentDate = currentDate.toISOString().split('T')[0];
      let dateDiffInDays = null;
      if(tmprecords.date_fin < formattedCurrentDate)
      {
           dateDiffInDays = (new Date(formattedDate) - new Date(formattedCurrentDate)) / (1000 * 60 * 60 * 24);
  
      }else{
           dateDiffInDays = (new Date(formattedDate) - new Date(tmprecords.date_fin)) / (1000 * 60 * 60 * 24);
      }
      setTotalPaid(parseFloat(pricePub) * Math.ceil(dateDiffInDays));  // Mise à jour de totalPaid
    }
  }, [formattedDate]);

  const handleDeleteImage = async (id,idImage)=>{
     await axios.delete(`${process.env.REACT_APP_BASE_URL}/api/restaurant/delete/${id}/${idImage}`)
           .then((res)=>{
              if(res.data.status === 200)
              {
                  setPictures(res.data.pictures)
                  toast.success("Image supprimer avec success")
                  return;
              }
              if(res.data.status === 422)
              {
                  toast.success(res.data.message)
                  return;
              }
           }).catch((err)=>{
              console.log("Erreur lors de l'appel a l'API ",err)
           })
  }

   const {t} = useTranslation()
   const lang = localStorage.getItem("langague");

  return (
    <div className="flex flex-row bg-[#eeee]">
      {loading ? (
        // Afficher le spinner tant que loading est true
        <Loading />
      ) : (
        <>
          <div className="w-screen  barre_scroll h-screen">
            {/* navbar top orange */}
            <SidebarTop />
            {/* navbar top gris*/}
            <div className="bg-[#f7f7f7] sm:h-10 s:h-14 mt-[50px]">
              <Breadcrumbs>
                <Link to="" className="opacity-60 md:text-base s:text-xs">
                  {t("Mes publications")}
                </Link>
                <Link
                  to="/Dashboard/Publications/Restaurant/Voir_des_restaurants"
                  className="opacity-60 md:text-base s:text-xs"
                >
                  Restaurant
                </Link>
                <Link to="" className="md:text-base s:text-xs">
                  {t("Modifier")}
                </Link>
              </Breadcrumbs>
            </div>

            <div>
              <ToastContainer />
            </div>

            <Link to="/Dashboard/Publications/Restaurant/Voir_des_restaurants">
              <div className="flex flex-row items-center space-x-2 relative top-8 s:left-5 sm:left-12 w-[280px]">
                <GoArrowLeft className="text-[#fe7f2d]  text-lg" />
                <p>{t("Retour à la page précedente")}</p>
              </div>
            </Link>

            {/* container formulaire */}
            <div className="flex justify-center py-20">
              <form onSubmit={handleSubmit} className="flex flex-col space-y-3">
                <div className="bg-white s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px] rounded-md border-b-8  shadow flex flex-col space-y-6 ">
                  {/* Ajout des images */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <MdOutlineAddPhotoAlternate className="text-xl text-[#fe7f2d]" />
                      <label> {t("Ajouter des images du restaurant")}</label>
                      <div onClick={()=>setOpen(true)}  className="text-blue-500 cursor-pointer ">
                        {pictures.length + t(" files")}
                      </div>
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      name="photo"
                      id="photo"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 "
                    />
                  </div>
                  {/* Nom du restaurant */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <MdOutlineHomeWork className="text-xl text-[#fe7f2d]" />
                      <label>{t("Nom du restaurant")}</label>
                    </div>
                    <input
                      //required
                      type="text"
                      defaultValue={tmprecords.title_announce}
                      onChange={handleInputChange}
                      name="nom"
                      placeholder="Ex : Lorenzo"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.nom && <p className="text-red-500">{errors.nom}</p>}
                  </div>

                  {/* Type de paiement */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <MdOutlinePayment className="text-xl text-[#fe7f2d]" />
                      <label>{t("Méthode de paiement")}</label>
                    </div>
                    <select
                      onChange={handleInputChange}
                      name="methode"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                      required
                    >
                      <option value=""></option>
                      {tmprecords.payment_method === 1 ? (
                        <option value="1" selected>
                          {t("Paiement en ligne et sur place")}
                        </option>
                      ) : (
                        <option value="1">
                          {t("Paiement en ligne et sur place")}
                        </option>
                      )}

                      {tmprecords.payment_method === 2 ? (
                        <option value="2" selected>
                          {t("Paiement en ligne")}
                        </option>
                      ) : (
                        <option value="2">{t("Paiement en ligne")}</option>
                      )}

                      {tmprecords.payment_method === 3 ? (
                        <option value="3" selected>
                          {t("Paiement sur place")}
                        </option>
                      ) : (
                        <option value="3">{t("Paiement sur place")}</option>
                      )}
                    </select>
                    {errors.methode && <p className='text-red-500'>{errors.methode}</p>}
                  </div>
                </div>

                <div className="bg-white s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px] rounded-md border-b-8  shadow flex flex-col space-y-3 ">
                  {/* Service du restaurant */}
                  <p className="font-semibold text-lg">{t("Service du restaurant")}</p>
                  <div className="grid sm:grid-cols-3 s:grid-cols-2 xs:grid-cols-4 gap-y-8">
                    {/* piscine */}
                    <div className=" flex flex-col space-y-2">
                      <div className="flex flex-row items-center space-x-2">
                        <MdOutlinePool className="text-xl text-[#fe7f2d]" />
                        <label>{t("Piscine")}</label>
                      </div>

                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_swimming_pool === 1 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="piscine"
                            value="1"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="piscine"
                            value="1"
                          />
                        )}

                        <label>{t("Oui")}</label>
                      </div>
                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_swimming_pool === 0 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="piscine"
                            value="0"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="piscine"
                            value="0"
                          />
                        )}

                        <label>{t("Non")}</label>
                        {errors.piscine && <p className='text-red-500'>{errors.piscine}</p>}
                      </div>
                    </div>
                    {/* Wifi  */}
                    <div className=" flex flex-col space-y-2">
                      <div className="flex flex-row items-center space-x-2">
                        <MdOutlineWifi className="text-xl text-[#fe7f2d]" />
                        <label>{t("Wifi")} </label>
                      </div>

                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_wifi === 1 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="wifi"
                            value="1"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="wifi"
                            value="1"
                          />
                        )}

                        <label>{t("Oui")}</label>
                      </div>
                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_wifi === 0 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="wifi"
                            value="0"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="wifi"
                            value="0"
                          />
                        )}

                        <label>{t("Non")}</label>
                        {errors.wifi && <p className='text-red-500'>{errors.wifi}</p>}
                      </div>
                    </div>
                    {/* TV */}
                    <div className=" flex flex-col space-y-2">
                      <div className="flex flex-row items-center space-x-2">
                        <SlScreenDesktop className="text-xl text-[#fe7f2d]" />
                        <label>TV</label>
                      </div>

                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_security === 1 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="TV"
                            value="1"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="TV"
                            value="1"
                          />
                        )}
                        <label>{t("Oui")}</label>
                      </div>
                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_security === 0 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="TV"
                            value="0"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="TV"
                            value="0"
                          />
                        )}

                        <label>{t("Non")}</label>
                        {errors.camera && <p className='text-red-500'>{errors.camera}</p>}
                      </div>
                    </div>
                    {/* Pétit déjeuner */}
                    <div className=" flex flex-col space-y-2">
                      <div className="flex flex-row items-center space-x-2">
                        <LiaUmbrellaBeachSolid className="text-xl text-[#fe7f2d]" />
                        <label>{t("Terasse")}</label>
                      </div>

                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_balcony === 1 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="terasse"
                            value="1"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="terasse"
                            value="1"
                          />
                        )}

                        <label>{t("Oui")}</label>
                       
                      </div>
                      <div className="flex flex-row items-center space-x-2">
                        {tmprecords.realstate_balcony === 0 ? (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="terasse"
                            value="0"
                            defaultChecked={true}
                          />
                        ) : (
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            name="terasse"
                            value="0"
                          />
                        )}

                        <label>{t("Non")}</label>
                        {errors.balcon && <p className='text-red-500'>{errors.balcon}</p>}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-white s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px] rounded-md border-b-8  shadow flex flex-col space-y-3 ">
                  {/* Tarif */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <GiMoneyStack className="text-xl text-[#fe7f2d]" />
                      <label>{t("Tarif minimun")}</label>
                    </div>
                    <input
                      defaultValue={tmprecords.price_announce}
                      onChange={handleInputChange}
                      type="number"
                      name="prix"
                      required
                      placeholder="Ex : 10000 "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.prix && <p className='text-red-500'>{errors.prix}</p>}
                  </div>
                  {/* Description */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <AiOutlineEdit className="text-xl text-[#fe7f2d]" />
                      <label>{t("Description du restaurant")}</label>
                    </div>
                    <textarea
                      defaultValue={tmprecords.description_announce}
                      onChange={handleInputChange}
                      name="msg"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] rounded p-2 h-[200px]"
                    ></textarea>
                    {errors.desc && <p className='text-red-500'>{errors.desc}</p>}
                  </div>
                </div>

                <div className="bg-white  s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px]  rounded-md border-b-8  shadow flex flex-col space-y-6 ">
                  {/* Tel */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <FaPhoneAlt className=" text-[#fe7f2d]" />
                      <label>{t("Telephone")}</label>
                    </div>
                    <input
                      type="tel"
                      defaultValue={tmprecords.contact_phone}
                      name="phone"
                      onChange={handleInputChange}
                      placeholder="Ex : +225 xxx xxx xxxx "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.tel && <p className="text-red-500">{errors.tel}</p>}
                  </div>
                  {/* Mail */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoIosMail className=" text-[#fe7f2d]" />
                      <label>{t("Adresse e-mail")}</label>
                    </div>
                    <input
                      type="email"
                      defaultValue={tmprecords.contact_email}
                      name="mail"
                      onChange={handleInputChange}
                      placeholder="Ex : info@monbonsejour.com "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.mail &&  <p className='text-red-500'>{errors.mail}</p>}
                  </div>
                  {/* Country */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoMdPin className=" text-[#fe7f2d]" />
                      <label>{t("Pays")}</label>
                    </div>
                       <Form.Group>
                            <Select
                                onChange={handleCountryChange}
                                name="country"  
                                value={address.code ? { 
                                       label: lang === 'fr' ? countries.find(pay => pay?.code === address.code)?.fr_Name
                                       : countries.find(pay => pay?.code === address.code)?.Name,
                                        value: address.code } : null} // Inclut la propriété value
                                options={countries.map(pay => ({
                                    label: lang === 'fr' ? pay?.fr_Name : pay?.Name,
                                    value: pay?.code
                                }))}
                                className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                            />
                       </Form.Group>
                    {/* <select
                      onChange={handleCountryChange}
                      name="country"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                    >
                      <option value={address.code}>{address.fr_Name}</option>
                      {countries.map((option, index) => (
                        <option key={index} value={option.code}>
                          {option.fr_Name}
                        </option>
                      ))}
                    </select> */}
                    {errors.pays && <p className='text-red-500'>{errors.pays}</p>}
                  </div>
                  {/* Province */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoMdPin className=" text-[#fe7f2d]" />
                      <label>{t("Province")}</label>
                    </div>
                    <Form.Group>
                      <Select
                          onChange={handleProvinceChange}
                          name="province"  
                          value={address.code_province ? { 
                                 label: lang === 'fr' ? provinces.find(prov => prov?.code_province === address.code_province)?.fr_Name
                                 : provinces.find(prov => prov?.code_province === address.code_province)?.Name, 
                                 value:address.code_province} : null} // Inclut la propriété value
                          options={provinces.map(prov => ({
                              label: lang === 'fr' ? prov?.fr_Name : prov?.Name ,
                              value: prov?.code_province
                          }))}
                          className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                      />
                    </Form.Group>
                    {/* <select
                      onChange={handleProvinceChange}
                      name="province"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                    >
                      <option value={address.code_province}>
                        {address.pname}
                      </option>
                      {provinces.map((option, index) => (
                        <option key={index} value={option.code_province}>
                          {option.fr_Name}
                        </option>
                      ))}
                    </select> */}
                    {errors.province && <p className='text-red-500'>{errors.province}</p>}
                  </div>
                  {/* Ville */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoMdPin className=" text-[#fe7f2d]" />
                      <label>{t("Ville")}</label>
                    </div>
                      <Form.Group>
                              <Select
                                  onChange={handleCityChange}
                                  name="ville"  
                                  value={address.code_city ? { 
                                         label: lang === 'fr' ? cities.find(city => city?.code_city === address.code_city)?.fr_Name
                                         :cities.find(city => city?.code_city === address.code_city)?.Name, 
                                         value: address.code_city} : null} // Inclut la propriété value
                                  options={cities.map(city => ({
                                      label: lang === 'fr' ? city?.fr_Name : city?.Name,
                                      value: city?.code_city
                                  }))}
                                  className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                              />
                      </Form.Group>
                    {/* <select
                      onChange={handleInputChange}
                      name="ville"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                    >
                      <option value={address.code_city}>{address.cname}</option>
                      {cities.map((option, index) => (
                        <option key={index} value={option.code_city}>
                          {option.fr_Name}
                        </option>
                      ))}
                    </select> */}
                    {errors.mail && <p className='text-red-500'>{errors.mail}</p>}
                  </div>
                  {/* Lieu */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoMdPin className=" text-[#fe7f2d]" />
                      <label>{t("Lieu")}</label>
                    </div>
                    <input
                      type="text"
                      defaultValue={tmprecords.contact_address}
                      name="lieu"
                      onChange={handleInputChange}
                      placeholder="Ex : Cocody, Abidjan, Côte d'ivoire "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.adresse && <p className='text-red-500'>{errors.adresse}</p>}
                  </div>
                </div>

                <div className="bg-white s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px] rounded-md border-b-8  shadow flex flex-col space-y-3 ">
                  {/* date debut */}
                  {/* <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <CiCalendarDate className=" text-[#fe7f2d]" />
                      <label>Date de debut affichage</label>
                    </div>
                    <input
                      defaultValue={tmprecords.date_debut}
                      name="date_debut"
                      onChange={handleInputChange}
                      type="date"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                      required
                    />
                    {errors.date_debut && <p className='text-red-500'>{errors.date_debut}</p>}
                  </div> */}

                  {/* date fin */}
                  {/* <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <CiCalendarDate className=" text-[#fe7f2d]" />
                      <label>Date de fin affichage</label>
                    </div>
                    <input
                      defaultValue={tmprecords.date_fin}
                      name="date_fin"
                      onChange={handleInputChange}
                      type="date"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                      required
                    />
                    {errors.date_fin && <p className='text-red-500'>{errors.date_fin}</p>}
                  </div> */}

                  <div className="flex flex-row items-center space-x-2">
                      <input
                        onClick={checkboxClick}
                        type="checkbox"                       
                      />
                      <label>{t("Ajouter des jours")}?</label>
                   </div>
                   {
                    showInput &&(
                        <input
                        type="text"
                        name="days"
                        onChange={handleDaysChange}
                        placeholder={t("Entrer le nombre de jours que vous voulez?")}
                        className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                      />
                    )
                   }
                   
                   <div className="bg-blue-900 rounded-lg shadow-lg p-6 text-white max-w-md mx-auto my-4">
                    <h3 className="text-xl font-semibold mb-4 border-b border-blue-700 pb-2">{t("Affichage")}:</h3>
                    <div className="space-y-2">
                      <div className="flex items-center">
                        <span className="font-medium w-32">{t("Date de début")}:</span>
                        <span className="bg-blue-800 px-3 py-1 rounded">
                          {new Date(tmprecords.date_debut).toLocaleDateString('fr-FR')}
                        </span>
                      </div>
                      <div className="flex items-center">
                      <span className="font-medium w-32">{t("Date de fin")}:</span>
                        <span className="bg-blue-800 px-3 py-1 rounded">
                          {new Date(tmprecords.date_fin).toLocaleDateString('fr-FR')}
                        </span>
                      </div>

                      {
                        !isNaN(daysToAdd) && new Date(formattedDate).toLocaleDateString("fr-FR") !== "01/01/1970"  && (
                          <>
                               <div className="mb-4 border-b border-blue-700 pb-2  flex items-center">
                                <span className="font-medium w-32">{t("Nouvelle")} <br/> {t("date de fin")}:</span>
                                  <span className="bg-blue-800 px-3 py-1 rounded">
                                    {new Date(formattedDate).toLocaleDateString(
                                      "fr-FR"
                                    )}
                                  </span>
                              </div>
                              <div className="flex items-center">
                              <span className="font-medium w-32">{t("Nombre de")}  <br/> {t("jour(s) restant")}:</span>
                                <span className="bg-blue-800 px-3 py-1 rounded">
                                   {dayr}
                                </span>
                              </div>
                          </>
                        )
                      }
                    </div>
                  </div>
                </div>

                <button className="bg-[#FCCA46] w-[150px] h-10 rounded text-white">
                  {t("Modifier")}
                </button>
              </form>

              {
                showPopup && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg p-6 w-full max-w-3xl relative max-h-screen overflow-y-auto">
                        {/* Bouton de fermeture à l'intérieur du modal */}
                        <button
                        onClick={() => setOpen(false)}
                        className="absolute top-3 right-3 text-red-500 text-2xl"
                    >
                        &times;
                    </button>
                        <Create item="Rechargement de la carte AZ"  options={options} onSuccess={SubmitEditForm} ></Create>
                    </div>
                </div>
                )
              }
              

               {/** Modal d'image */}
               {
                  open && (
                    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
                      <div className="bg-white rounded-lg p-6 w-full max-w-3xl relative max-h-screen overflow-y-auto">
                        {/* Bouton de fermeture à l'intérieur du modal */}
                        <button
                          onClick={() => setOpen(false)}
                          className="absolute top-3 right-3 text-red-500 text-2xl"
                        >
                          &times;
                        </button>
                        
                        <h2 className="text-center text-xl font-semibold mb-4">{t("Les images de")} {tmprecords.title_announce}</h2>
                        
                        <div className="grid grid-cols-3 gap-4">
                          {pictures.map((picture, index) => (
                            <div key={index} className="relative">
                              <img
                                src={`data:image/png;base64,${picture.picture}`} 
                                alt="image preview"
                                className="w-full h-auto rounded-lg"
                              />
                              <button
                                 onClick={()=>handleDeleteImage(id,picture.id)} // Logic to remove image (if implemented)
                                className="absolute top-0 right-0 bg-red-500 text-white rounded-full p-1"
                              >
                                &times;
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )
                }

            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default EditRestaurant;
